import { render, staticRenderFns } from "./TransactionView.vue?vue&type=template&id=7b360880&"
import script from "./TransactionView.vue?vue&type=script&lang=ts&"
export * from "./TransactionView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports